module.exports = __webpack_public_path__ + "static/img/7617859225ecac7a655af43c6fb24da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_wztq.png
// module id = kbX2
// module chunks = 1